import moment from "moment"

function dateTimeToString(dateString: string) {
  return moment(dateString).utc().format('YYYY-MM-DD HH:mm:ss');
}

export default dateTimeToString
